<template>
  <div ref="pageView" class="pdfViewer"></div>
</template>

<style scoped lang="less">

</style>

<script>
import * as OFDJS from './ofd';

export default {
  name: "ofd-view",
  props: {
    eventBus: Object
  },
  data() {
    return {}
  },
  mounted() {
    const pageView = this.$refs.pageView
    this.ofdViewer = new OFDJS.OFDViewer({
      container: pageView.parentNode,
      viewer: pageView,
      eventBus: this.eventBus,
      removePageBorders: true
    })
  },
  methods: {
    load(file) {
      if (!file) return

      if (this.loadingTask) {
        return this.cancel().then(() => this.load(file))
      }

      const self = this
      this.loadingTask = OFDJS.loadDocument(file)
      return this.loadingTask.promise.then((res) => {
        self.ofdViewer.setDocument(res[0])
        return self.ofdViewer
      })
    },
    cancel() {
      if (!this.loadingTask) {
        return Promise.resolve()
      }

      const promise = this.loadingTask.promise
      this.loadingTask.cancel()
      this.loadingTask = null
      this.ofdViewer.setDocument(null)

      return promise;
    }
  }
}
</script>